// src/pages/produtos/subGrupos/SubGrupoSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useSubGrupo } from '../../../contexts/produtos/SubGrupoContext';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalTable from '../../../components/modalForm/ModalTable';

import LazyLoading from '../../../components/modalForm/LazyLoading';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalSearchBar from '../../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';
import ModalSelectButton from '../../../components/modalForm/ModalSelectButton';

const SubGrupoSearch = ({ show, onHide, onSelectSubGrupo, grupoIdSel }) => {
    const { subGrupos } = useSubGrupo();
    const [filter, setFilter] = useState('');
    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');

    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            setFilter('');
            if (inputRef.current) {
                inputRef.current.focus();
            }

        }
    }, [show]);

    if (!show) return null;

    // Filtra os subgrupos pela descrição e, se grupoIdSel existir, pelo grupoId
    const filteredSubGrupos = subGrupos.filter(subGrupo =>
        subGrupo.descricao.toLowerCase().includes(filter.toLowerCase()) &&
        (!grupoIdSel || subGrupo.grupoId === grupoIdSel)
    );

    const sortedSubGrupos = [...filteredSubGrupos].sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        } else if (sortField === 'descricao') {
            const descriptionA = a.descricao.toLowerCase();
            const descriptionB = b.descricao.toLowerCase();
            if (descriptionA < descriptionB) return sortDirection === 'asc' ? -1 : 1;
            if (descriptionA > descriptionB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }
        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (subGrupo) => {
        onSelectSubGrupo(subGrupo);
        onHide();
    };

    return (
        <ModalContainer show={show} largura="600px" variant="busca" onHide={onHide}>

            <ModalHeader title="Buscar SubGrupo" onHide={onHide} />
            <ModalBody className="modal-body">
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por descrição..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading
                    items={sortedSubGrupos}
                    resetKey={`${filter}|${grupoIdSel}|${sortField}|${sortDirection}`}
                >
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable
                    containerRef={containerRef}
                    containerStyle={{ maxHeight: '55vh', overflowY: 'auto' }}
                    onContainerScroll={handleScroll}
                >
                    <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    onClick={() => handleSort('id')}
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }}
                                    tabIndex={0}
                                 type="button">
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" scope="col" style={{ width: '60%' }} aria-sort={sortField === 'descricao' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    onClick={() => handleSort('descricao')}
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }}
                                    tabIndex={0}
                                 type="button">
                                    Descrição
                                    {sortField === 'descricao' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '20%' }}>
                                Selecionar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map((subGrupo) => (
                            <tr
                                key={subGrupo.id}
                                onDoubleClick={() => handleDoubleClick(subGrupo)}
                            >
                                <td className="text-end align-middle">{subGrupo.id}</td>
                                <td className="text-start align-middle">{subGrupo.descricao}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={() => onSelectSubGrupo(subGrupo)}
                                        style={{ padding: '2px 6px' }}
                                     label={subGrupo.descricao} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter className="modal-footer">
                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>

        </ModalContainer>
    );
};

export default SubGrupoSearch;
